import { Events, OrientationAxis } from '../../../enums/index.js';
import triggerEvent from '../../../utilities/triggerEvent.js';
export function triggerPlanarNewImage(ctx, args = {}) {
    triggerEvent(ctx.viewport.element, Events.STACK_NEW_IMAGE, {
        image: args.image,
        imageId: args.imageId ?? args.image?.imageId,
        imageIdIndex: args.imageIdIndex,
        viewportId: ctx.viewportId,
        renderingEngineId: ctx.renderingEngineId,
    });
}
export function triggerPlanarVolumeNewImage(ctx, params) {
    const orientation = params.camera?.orientation;
    const isAcquisitionAligned = !orientation ||
        orientation === OrientationAxis.ACQUISITION ||
        (params.acquisitionOrientation !== undefined &&
            orientation === params.acquisitionOrientation);
    if (isAcquisitionAligned &&
        typeof params.imageIdIndex === 'number' &&
        params.imageIds[params.imageIdIndex]) {
        triggerPlanarNewImage(ctx, {
            imageId: params.imageIds[params.imageIdIndex],
            imageIdIndex: params.imageIdIndex,
        });
    }
    else {
        triggerPlanarNewImage(ctx);
    }
    if (typeof params.imageIdIndex === 'number') {
        triggerEvent(ctx.viewport.element, Events.VOLUME_NEW_IMAGE, {
            imageIndex: params.imageIdIndex,
            numberOfSlices: params.maxImageIdIndex + 1,
            viewportId: ctx.viewportId,
            renderingEngineId: ctx.renderingEngineId,
        });
    }
}
